/*LIBRARY*/
import { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import CheckBox from "../common_input/CheckBox";
import SelectDataPembanding from "../editor_search_import/SelectDataPembanding";
import DeleteDataFormOverlay from "./DeleteDataFormOverlay";
import SelectDataForm from "../editor_search_import/SelectDataForm";
import SpatialJoin from "./SpatialJoin";
import EditRadiusPembanding from "./EditRadiusPembanding";
import MANAGE_CHART from "./MANAGE_CHART";

/*REDUX*/
import { setField, setLayerWOgeojson } from "../../App/actions/layerActions";
import {
  editLayerGeneral,
  editLayerGeneralAttached,
} from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { openModal, initApi } from "../../App/actions/authActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import {
  get_layer_id_ai,
  push_layer_id_ai,
  pull_layer_id_ai,
  get_request_resume_status,
  set_value_ai_preset,
} from "../../App/actions/ai_preset_actions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import icon_copy from "../../Assets/svg/icon_copy.svg";
import icon_copied from "../../Assets/svg/icon_copied.svg";

/*FUNCTION*/
import uuid from "../../App/validation/uuid";

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

/*CONST*/

const EditLayer = ({
  layer,
  project,
  auth,
  properties,
  setField,
  editLayerGeneral,
  editLayerGeneralAttached,
  initApi,
  set_value_layer,
  set_value_properties,
  get_layer_id_ai,
  get_request_resume_status,
  set_value_ai_preset,
  toggle_edit_general,
  post_activities,
}) => {
  const [geo_layer, set_geo_layer] = useState({});
  const [fields, set_fields] = useState("");
  const [modal_clone_field, set_modal_clone_field] = useState(false);
  const [modal_select_comparison_data, set_modal_select_comparison_data] =
    useState(false);
  const [modal_select_data_form, set_modal_select_data_form] = useState(false);
  const [modal_spatial_join, set_modal_spatial_join] = useState(false);
  const [modal_edit_radius_pembanding, set_modal_edit_radius_pembanding] =
    useState(false);
  const [modal_manage_chart, set_modal_manage_chart] = useState(false);

  const is_mobile = properties?.is_mobile;

  useEffect(() => {
    const { layer_id, geo_layer_list } = layer;
    const found_geo_layer = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id,
    );
    set_geo_layer(found_geo_layer);
    get_layer_id_ai();
    get_request_resume_status(layer_id);
    set_value_ai_preset({
      key: "current_progress_demo",
      value: 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const on_open_modal_edit_label_config = () => {
    set_value_properties({
      key: "modal_edit_label_config",
      value: true,
    });
    toggle_edit_general();
  };

  const [share_link_copied, set_share_link_copied] = useState("");

  const on_copy_clipboard = useCallback((text, new_share_link_copied) => {
    navigator.clipboard.writeText(text);
    set_share_link_copied(new_share_link_copied);

    setTimeout(() => {
      set_share_link_copied("");
    }, 1000);
  }, []);

  const on_open_modal_edit_layer_style = () => {
    set_value_properties({
      key: "modal_edit_layer_style",
      value: true,
    });
    toggle_edit_general();
  };

  const toggle_edit_chart = () => {
    set_modal_manage_chart(!modal_manage_chart);
  };

  const toggle_edit_radius_pembanding = () => {
    set_modal_edit_radius_pembanding(!modal_edit_radius_pembanding);
  };

  const toggle_spatial_join = () => {
    set_modal_spatial_join(!modal_spatial_join);
  };

  const toggle_link_edit = () => {
    toggle_edit_general();
    set_value_layer({
      key: "modal_link_edit",
      value: !layer.modal_link_edit,
    });
  };

  const toggle_select_comparison_data = () => {
    set_modal_select_comparison_data(!modal_select_comparison_data);
  };

  const toggle_select_data_form = () => {
    set_modal_select_data_form(!modal_select_data_form);
  };

  const toggle_clone_field = () => {
    set_modal_clone_field(!modal_clone_field);
  };

  const handleChange = (e) => {
    e.preventDefault();
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const name = e.target.name;
    if (name === "fields") {
      set_fields(value);
    } else if (name === "folder") {
      set_geo_layer({
        ...geo_layer,
        folder: value,
      });
    } else {
      set_geo_layer({
        ...geo_layer,
        geo_layer: {
          ...geo_layer.geo_layer,
          [name]: value,
        },
      });
    }
  };

  const handleToggle = (e) => {
    const name = e.target.name;
    const value = e.target.checked;
    set_geo_layer({
      ...geo_layer,
      geo_layer: {
        ...geo_layer.geo_layer,
        [name]: value,
      },
    });
  };

  const handleSubmitField = (e) => {
    e.preventDefault();
    const current_geo_layer = geo_layer.geo_layer;
    const { geo_layer_list } = layer;
    const field = geo_layer_list[fields].geo_layer.fields;
    const new_field = field.map((f) => {
      let new_field_item = { ...f, uuid: uuid() };
      return new_field_item;
    });
    const { _id } = current_geo_layer;
    const body = {
      geo_layer_id: _id,
      field: new_field,
    };
    setField(body);
    toggle_edit_general();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const current_geo_layer = geo_layer.geo_layer;
    const {
      _id,
      name,
      description,
      is_form_login_req,
      isPublic,
      show_only_highlight_field,
      isFormPublic,
      isLocationChangeable,
      picture_url,
      isCustomFormMessage,
      customFormMessageHeader,
      customFormMessageDesc,
      is_survey,
      is_use_bounding_box,
      webhook,
    } = current_geo_layer;
    let folder = geo_layer.folder;
    if (folder === undefined) {
      folder = layer.geo_layer_wo_geojson.folder;
    }
    const body = {
      geo_layer_id: _id,
      folder,
      name,
      description,
      is_form_login_req: is_form_login_req ? is_form_login_req : false,
      isPublic,
      show_only_highlight_field,
      isFormPublic,
      isLocationChangeable,
      picture_url,
      isCustomFormMessage,
      customFormMessageHeader,
      customFormMessageDesc,
      is_survey,
      is_use_bounding_box,
      webhook,
    };
    editLayerGeneral(body);
  };

  const handleSubmitAttached = (e) => {
    e.preventDefault();
    const current_geo_layer = geo_layer.geo_layer;
    const { geo_project } = project;
    const { _id } = current_geo_layer;
    const folder = geo_layer.folder;
    const body = {
      geo_project_id: geo_project._id,
      geo_layer_id: _id,
      folder,
    };
    editLayerGeneralAttached(body);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { domain, user } = auth;
  const { geo_project } = project;
  const { geo_layer_list, loadingProcess, itemLoading } = layer;

  //content
  const geo_layer_id = layer?.layer_id;
  const api_keys = user?.api_keys ? user.api_keys : [];
  const domain_temp = domain_list?.[domain]?.form_link;
  const layer_form_list = layer?.geo_layer?.geo_layer?.layer_form_list || [];
  const { folders } = geo_project;
  let folders_state = folders.slice();
  folders_state.unshift({ name: "Outside folders", _id: "" });
  const layer_inside = geo_layer?.geo_layer || {};
  const status = geo_layer?.status;
  const architecture = geo_layer?.geo_layer?.architecture;
  let final_content;
  let button_save_content;
  let button_edit_attached;

  if (loadingProcess && itemLoading === "edit_general") {
    button_save_content = (
      <div className="button_big background_black">
        {dict?.["Saving"]?.[language]}...
      </div>
    );
  } else {
    button_save_content = (
      <button onClick={handleSubmit} className="button_big background_black">
        {dict?.["Save"]?.[language]}
      </button>
    );
  }
  if (loadingProcess && itemLoading === "edit_general_attached") {
    button_edit_attached = (
      <div className="button_big background_black">
        {dict?.["Saving"]?.[language]}...
      </div>
    );
  } else {
    button_edit_attached = (
      <button type="submit" className="button_big background_black">
        {dict?.["Save"]?.[language]}
      </button>
    );
  }
  let open_api_content = (
    <main>
      <p className="text_medium sub_color">
        {dict?.["You don't have an API key yet"]?.[language]}
      </p>
      <button className="button background_black" onClick={() => initApi()}>
        {dict?.["Create a new API key"]?.[language]}
      </button>
    </main>
  );
  if (api_keys.length > 0) {
    open_api_content = (
      <main>
        <div className="container background_white outline_grey text_medium">
          <section className="two_container_auto full_width">
            <a
              className="text_medium"
              href={`https://geoserver.mapid.io/layers_new/get_layer?api_key=${api_keys?.[0]?.key}&layer_id=${layer_inside?._id}&project_id=${geo_project?._id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2196f3" }}
              data-mapid="clickLink"
            >
              {`https://geoserver.mapid.io/layers_new/get_layer?api_key=${api_keys?.[0]?.key}&layer_id=${layer_inside?._id}&project_id=${geo_project?._id}`}
            </a>
            <div className="text_right">
              <img
                title="Salin API"
                width={21}
                alt="Copy"
                src={
                  share_link_copied === "API Tersalin" ? icon_copied : icon_copy
                }
                className="cursor_pointer"
                onClick={() => {
                  on_copy_clipboard(
                    `https://geoserver.mapid.io/layers_new/get_layer?api_key=${api_keys?.[0]?.key}&layer_id=${layer_inside?._id}&project_id=${geo_project?._id}`,
                    "API Tersalin",
                  );
                  post_activities({
                    action: "copy_open_api",
                    layer_id: layer?.layer_id,
                  });
                }}
              />
            </div>
          </section>
        </div>
      </main>
    );
  }
  const webhook = (
    <main>
      <section className="text_bold">WEBHOOK</section>
      <p className="text_medium sub_color margin_bottom">
        {
          dict?.[
            "Use Webhooks to call external APIs when new data is added via FORM"
          ]?.[language]
        }
      </p>
      <input
        type="text"
        name="webhook"
        id="webhook"
        value={layer_inside?.webhook || ""}
        defaultValue={layer_inside?.webhook}
        onChange={handleChange}
        className="margin_bottom"
      />
    </main>
  );
  if (status === "attached") {
    //untuk kasus layer yang dilampirkan, hanya bisa mengedit folder di dalam project yang sedang dibuka
    final_content = (
      <main>
        <form onSubmit={handleSubmitAttached}>
          <section className="container background_grey_light outline_grey margin_bottom">
            <p className="text_bold">{dict?.["General"]?.[language]}</p>
            <p className="text_medium sub_color">
              _id: {geo_layer?.geo_layer?._id}
            </p>
            <p className="text_medium sub_color">
              link: {geo_layer?.geo_layer?.link}
            </p>
          </section>
          <section className="container background_grey_light outline_grey margin_bottom">
            <section className="text_bold">
              {dict?.["Edit Folder"]?.[language]}
            </section>
            <section className="text_medium sub_color margin_bottom">
              {
                dict?.[
                  "In the case of attached layer, you only can edit folder in this project"
                ]?.[language]
              }
            </section>
            <select
              id="folder"
              name="folder"
              value={geo_layer?.folder || ""}
              onChange={handleChange}
            >
              {folders_state.map(({ _id, name }, idx) => {
                return (
                  <option key={idx} value={_id}>
                    {name}
                  </option>
                );
              })}
            </select>
          </section>
          <section
            style={{
              textAlign: "center",
            }}
          >
            <div>{button_edit_attached}</div>
          </section>
        </form>
      </main>
    );
  } else {
    //untuk kasus layer asli yang ada di dalam project, tersedia semua kolom pengeditan

    const left_content = (
      <div>
        <section className="container background_grey_light outline_grey margin_bottom">
          <section className="text_bold">
            {dict?.["General"]?.[language]}
          </section>
          <section className="text_medium sub_color margin_bottom">
            {
              dict?.[
                "Rename, description, group position, and publication status (to display layer in the publication post)"
              ]?.[language]
            }
          </section>
          <input
            type="text"
            name="name"
            id="name"
            value={layer_inside?.name || ""}
            onChange={handleChange}
            className="margin_bottom"
          />
          <textarea
            type="text"
            name="description"
            id="description"
            value={layer_inside?.description || ""}
            onChange={handleChange}
            rows="4"
            className="margin_bottom"
          />
          <select
            id="folder"
            name="folder"
            value={geo_layer?.folder || ""}
            onChange={handleChange}
          >
            {folders_state.map(({ _id, name }, idx) => {
              return (
                <option key={idx} value={_id}>
                  {name}
                </option>
              );
            })}
          </select>
          <CheckBox
            text="isPublic"
            title="Public Data"
            value={layer_inside?.isPublic || false}
            handle={handleToggle}
          />
          <CheckBox
            text="show_only_highlight_field"
            title={dict?.["Only show highlighted questions"]?.[language]}
            value={layer_inside?.show_only_highlight_field || false}
            handle={handleToggle}
          />
          {/* <CheckBox
                    text="is_use_bounding_box"
                    title="Get data by bounding box"
                    value={layer_inside?.is_use_bounding_box || false}
                    handle={handleToggle}
                  /> */}
        </section>
        <section>
          {architecture !== "api" && (
            <section className="container background_grey_light outline_grey margin_bottom">
              <div className="two_container_auto margin_bottom">
                <h1 className="text_bold">
                  {dict?.["Form config"]?.[language]}
                </h1>
                <div className="text_right">
                  <Link
                    to={`/form_editor/${layer_inside?.link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button background_black"
                    data-mapid="openFormEditor"
                    onClick={() => {
                      post_activities({ action: "open_form_editor" });
                    }}
                  >
                    {dict?.["Open form editor"]?.[language]}
                  </Link>
                </div>
              </div>

              <p className="text_medium sub_color margin_bottom">
                {
                  dict?.[
                    "Set up online form configurations to facilitate mass surveys to respondents"
                  ]?.[language]
                }
              </p>

              <CheckBox
                text="isLocationChangeable"
                title={dict?.["Changeable Location"]?.[language]}
                value={layer_inside?.isLocationChangeable || false}
                handle={handleToggle}
              />
              <CheckBox
                text="is_form_login_req"
                title="Required to login"
                value={layer_inside?.is_form_login_req || false}
                handle={handleToggle}
              />
              <CheckBox
                text="isFormPublic"
                title={dict?.["Public Form"]?.[language]}
                value={layer_inside?.isFormPublic || false}
                handle={handleToggle}
              />
              <CheckBox
                text="is_survey"
                title={dict?.["Survey manager"]?.[language]}
                value={layer_inside?.is_survey || false}
                handle={handleToggle}
              />

              <div className="container background_white outline_grey margin_bottom">
                <section className="two_container_auto full_width">
                  <a
                    className="text_medium"
                    href={`${domain_temp}${layer_inside?.link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#2196f3" }}
                    data-mapid="clickLink"
                  >
                    {`${domain_temp}${layer_inside?.link}`}
                  </a>
                  <div className="text_right">
                    <img
                      title="Salin Link"
                      width={21}
                      alt="Copy"
                      src={
                        share_link_copied === "Link Tersalin"
                          ? icon_copied
                          : icon_copy
                      }
                      className="cursor_pointer"
                      onClick={() => {
                        on_copy_clipboard(
                          `${domain_temp}${layer_inside?.link}`,
                          "Link Tersalin",
                        );
                      }}
                    />
                  </div>
                </section>
              </div>
              <section className="container background_white outline_grey margin_bottom">
                <div
                  onClick={toggle_link_edit}
                  className="button background_black margin_bottom"
                >
                  {dict?.["Edit Link Each Row"]?.[language]}
                </div>
                <p className="text_medium sub_color">
                  {
                    dict?.[
                      "Unique links to change specific data and allow respondents to edit their own data"
                    ]?.[language]
                  }
                </p>
              </section>
              <br />
              <section>
                <h1 className="text_bold">
                  {dict?.["MAPID FORM Overlay Data"]?.[language]}
                </h1>
                <p className="text_medium sub_color margin_bottom">
                  {
                    dict?.[
                      "Select the data to be overlaid on the MAPID FORM map as a survey guide for the surveyor"
                    ]?.[language]
                  }
                </p>
                <div
                  onClick={toggle_select_data_form}
                  className="button background_black"
                >
                  {dict?.["Choose"]?.[language]}
                </div>

                {layer_form_list.length > 0 && (
                  <>
                    <p className="text_medium sub_color margin_bottom">
                      {dict?.["Selected overlay data"]?.[language]}
                    </p>
                    <div className="overflow_x flex gap_10 w_full">
                      {layer_form_list.length > 0 ? (
                        layer_form_list.map((row, idx) => {
                          return (
                            <DeleteDataFormOverlay
                              key={idx}
                              name={row.name}
                              geo_layer_id={geo_layer_id}
                            />
                          );
                        })
                      ) : (
                        <p className="text_medium sub_color margin_bottom">
                          {dict?.["Have not selected overlay data"]?.[language]}
                        </p>
                      )}
                    </div>
                  </>
                )}
              </section>
            </section>
          )}
        </section>
      </div>
    );

    const right_content = (
      <div>
        <section className="container background_grey_light outline_grey margin_bottom">
          <div className="text_bold">
            {dict?.["Layer Styles and Charts"]?.[language]}
          </div>
          <p className="text_medium sub_color margin_bottom">
            {
              dict?.[
                "This configuration is to set the layer style homogeneously. For each layer type (Point, Line, Polygon) it has a different style configuration."
              ]?.[language]
            }
          </p>
          <button
            className="button margin_bottom margin_right background_black"
            onClick={on_open_modal_edit_layer_style}
            type="button"
            data-mapid="buttonStyle"
          >
            {dict?.["Layer Style"]?.[language]}
          </button>
          <button
            className="button margin_bottom margin_right background_black"
            onClick={on_open_modal_edit_label_config}
            type="button"
            data-mapid="clickLabeling"
          >
            {dict?.["Map labeling"]?.[language]}
          </button>
          <button
            className="button background_black"
            onClick={toggle_edit_chart}
          >
            {dict?.["Create chart"]?.[language]}
          </button>
        </section>

        <section className="container background_grey_light outline_grey margin_bottom">
          <p className="text_bold">OPEN API</p>
          <p className="text_medium sub_color margin_bottom">
            {
              dict?.[
                "The Get Data API allows you to get GeoJSON from a layer via an API."
              ]?.[language]
            }
          </p>
          {open_api_content}
          <br />
          {webhook}
        </section>
      </div>
    );
    final_content = (
      <main>
        <div>
          <main>
            {is_mobile ? (
              <>
                {left_content}
                {right_content}
              </>
            ) : (
              <div className="two_container_equal">
                {left_content}
                {right_content}
              </div>
            )}
          </main>
          <section
            style={{
              textAlign: "center",
              marginTop: "10px",
            }}
          >
            {button_save_content}
          </section>
        </div>
        {/* </form> */}
      </main>
    );
  }

  const modal_manage_chart_content = modal_manage_chart && (
    <Modal
      modalSize="large"
      id="modal_manage_chart"
      isOpen={modal_manage_chart}
      onClose={toggle_edit_chart}
      title={dict?.["Chart"]?.[language]}
    >
      <div className="box-body">
        <MANAGE_CHART />
      </div>
    </Modal>
  );

  const modal_select_comparison_data_content = modal_select_comparison_data && (
    <Modal
      modalSize="medium"
      id="modal_select_comparison_data"
      isOpen={modal_select_comparison_data}
      onClose={toggle_select_comparison_data}
    >
      <div className="box-body">
        <SelectDataPembanding
          toggle_select_comparison_data={toggle_select_comparison_data}
        />
      </div>
    </Modal>
  );

  const modal_select_data_form_content = modal_select_data_form && (
    <Modal
      modalSize="medium"
      id="modal_select_comparison_data"
      isOpen={modal_select_data_form}
      onClose={toggle_select_data_form}
    >
      <div className="box-body">
        <SelectDataForm toggle_select_data_form={toggle_select_data_form} />
      </div>
    </Modal>
  );

  const modal_clone_field_content = modal_clone_field && (
    <Modal
      modalSize="small"
      id="modal_clone_field"
      isOpen={modal_clone_field}
      onClose={toggle_clone_field}
    >
      <div className="box-body">
        <form onSubmit={handleSubmitField}>
          <div className="text_bold">
            {dict?.["Clone attributes from other layer"]?.[language]}
          </div>
          <div className="text_medium sub_color margin_bottom">
            {
              dict?.[
                "This action will overwrite the attribute list from other layer to this layer, do this if you want to clone attribute. Be careful this action can't be undone."
              ]?.[language]
            }
          </div>
          <select
            id="fields"
            name="fields"
            value={fields}
            onChange={handleChange}
          >
            {geo_layer_list.map((layer_item, idx) => {
              return (
                <option key={idx} value={idx}>
                  {layer_item?.geo_layer?.name}
                </option>
              );
            })}
          </select>
        </form>
      </div>
    </Modal>
  );

  const modal_spatial_join_content = modal_spatial_join && (
    <Modal
      modalSize="medium"
      id="modal_spatial_join"
      isOpen={modal_spatial_join}
      onClose={toggle_spatial_join}
    >
      <div className="box-body">
        <SpatialJoin />
      </div>
    </Modal>
  );

  const modal_edit_radius_pembanding_content = modal_edit_radius_pembanding && (
    <Modal
      modalSize="small"
      id="modal_edit_radius_pembanding"
      isOpen={modal_edit_radius_pembanding}
      onClose={toggle_edit_radius_pembanding}
    >
      <div className="box-body">
        <EditRadiusPembanding
          toggle_edit_radius_pembanding={toggle_edit_radius_pembanding}
        />
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_manage_chart_content}
      {modal_select_comparison_data_content}
      {modal_clone_field_content}
      {modal_select_data_form_content}
      {modal_spatial_join_content}
      {modal_edit_radius_pembanding_content}
      {final_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  loading_reducer: state.loading_reducer,
  layer: state.layer,
  project: state.project,
  auth: state.auth,
  ai_preset_reducer: state.ai_preset_reducer,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_ai_preset,
  setField,
  setLayerWOgeojson,
  openModal,
  editLayerGeneral,
  editLayerGeneralAttached,
  getDetailLayerById,
  initApi,
  set_value_layer,
  set_value_properties,
  get_layer_id_ai,
  push_layer_id_ai,
  pull_layer_id_ai,
  get_request_resume_status,
  post_activities,
})(EditLayer);
